export default __webpack_public_path__ + "static/dustin-bitmoji-29619c1e6e108e5e3beeac0bacc853a6.png";